// In-memory holder for ad click identifiers captured from the URL.
//
// Why this exists: the funnel preserves attribution by re-stamping click ids
// onto every navigation URL via genClidUrl(). gclid/fbclid are threaded through
// explicitly, but the newer identifiers (gbraid/wbraid/gad_source/...) would
// otherwise need to be passed through every call site. Holding them here lets
// the non-React genClidUrl() append the full set without touching call sites.
//
// These live only in memory (mirroring the in-memory gclid/fbclid atoms); the
// URL — re-stamped on every funnel navigation — is what actually carries them
// across page reloads.

// Every tracking query key we capture from the URL. Keep gclid/fbclid first:
// they are also handled explicitly by genClidUrl's positional args for
// backward compatibility, while the rest ride along automatically.
export const TRACKING_PARAM_KEYS = [
    "gclid",
    "fbclid",
    "gbraid",
    "wbraid",
    "gad_source",
    "gad_campaignid",
];

// Keys genClidUrl appends in addition to its explicit gclid/fbclid arguments.
export const EXTRA_TRACKING_KEYS = TRACKING_PARAM_KEYS.filter(
    (key) => key !== "gclid" && key !== "fbclid",
);

const store = {};

// Only ever set a key when a truthy value is present, so a later param-less
// page never clobbers an id captured on the landing URL.
export const setTrackingParam = (key, value) => {
    if (value) {
        store[key] = value;
    }
};

export const getTrackingParam = (key) => store[key] || null;

// The extra (non-gclid/fbclid) identifiers currently held, omitting empties.
export const getExtraTrackingParams = () => {
    const out = {};
    for (const key of EXTRA_TRACKING_KEYS) {
        if (store[key]) {
            out[key] = store[key];
        }
    }
    return out;
};
